import React, { useState } from 'react';
import { callDemo, demoErrorMessage } from './demoApi';

// Touchpoint 3: "Business name + city + what you do → your Google Business Profile description"
const GbpProfileDemo = () => {
  const [businessName, setBusinessName] = useState('');
  const [city, setCity] = useState('');
  const [whatYouDo, setWhatYouDo] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);

  const canSubmit = businessName.trim() && city.trim() && whatYouDo.trim() && !loading;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setLoading(true);
    setError('');
    setResult(null);
    try {
      const data = await callDemo('gbp_profile', {
        business_name: businessName.trim(),
        city: city.trim(),
        what_you_do: whatYouDo.trim(),
      });
      setResult(data);
    } catch (err) {
      setError(demoErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card demo-card">
      <div className="ic">📍</div>
      <h4>Your Google Business Profile description</h4>
      <p className="demo-sub">Business name, city, and what you do.</p>
      <input
        className="demo-input"
        type="text"
        placeholder="Business name"
        value={businessName}
        onChange={(e) => setBusinessName(e.target.value)}
        maxLength={120}
      />
      <input
        className="demo-input"
        type="text"
        placeholder="City (e.g. Orlando, FL)"
        value={city}
        onChange={(e) => setCity(e.target.value)}
        maxLength={80}
      />
      <input
        className="demo-input"
        type="text"
        placeholder="What you do (e.g. residential lawn care)"
        value={whatYouDo}
        onChange={(e) => setWhatYouDo(e.target.value)}
        maxLength={300}
        onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
      />
      <button className="demo-btn" onClick={handleSubmit} disabled={!canSubmit}>
        {loading ? 'Writing…' : 'Show me →'}
      </button>
      {error && <p className="demo-error">{error}</p>}
      {result && (
        <div className="demo-result">
          <h5>Google Business Profile description</h5>
          <p>{result.description}</p>
          {result.post_ideas?.length > 0 && (
            <>
              <h5 style={{ marginTop: 10 }}>Post ideas</h5>
              <ul>
                {result.post_ideas.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
      {result && (
        <a href="/order" className="demo-cta">
          Want this on your own site? $199, live in 48 hours →
        </a>
      )}
      <p className="demo-privacy">🔒 Nothing you type here is saved.</p>
    </div>
  );
};

export default GbpProfileDemo;
